module.exports = __webpack_public_path__ + "static/kubernetes-c2a3d1d77030edce4b452a51895fb0a7.svg";